// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { CompletionStatusType } from '../../types/Model';
import S from './styles';
import { FormattedMessage } from 'react-intl';

const CompletionStatusTag:React.FC<{ type: CompletionStatusType, score?: number }> = ({ type, score, ...props }):JSX.Element | null => {
  switch (type) {
    case CompletionStatusType.ENDED:
      return <S.EndedContainer {...props}><S.TickIcon /><FormattedMessage id="B034"/></S.EndedContainer>
    case CompletionStatusType.COMPLETED:
      if (score !== undefined) {
        return <S.CompletedWithScoreContainer {...props}>{score} %</S.CompletedWithScoreContainer>
      } else {
        return <S.CompletedContainer {...props}><S.TickIcon /><FormattedMessage id="B033"/></S.CompletedContainer>
      }
    case CompletionStatusType.INCOMPLETE:
      return <S.IncompleteContainer {...props}><S.UntickIcon /><FormattedMessage id="B035"/></S.IncompleteContainer>
    default:
      return null;
  }
}

export { CompletionStatusTag as default};
